import { ActionIcon, List, Tooltip } from '@mantine/core';
import { IconExclamationCircle } from '@tabler/icons-react';
import { when } from '../utils/when';
import { For } from './control-flow/For';
import { ValidationEntrySeverity } from './ValidationEntrySeverity';

export const ValidationEndAdornment = ({
    severity,
    helperText,
}: {
    severity: ValidationEntrySeverity | undefined;
    helperText: Array<string> | undefined;
}) => {
    if (!severity || !helperText) {
        return;
    }

    const label =
        helperText.length === 1 ?
            helperText[0]
        :   <List listStyleType={'none'}>
                <For
                    each={helperText}
                    keyFn={(item) => `ht_${item}`}
                >
                    {(item) => <List.Item>{item}</List.Item>}
                </For>
            </List>;

    return (
        <Tooltip label={label}>
            <ActionIcon
                size={'sm'}
                style={{ padding: '6px', backgroundColor: 'inherit' }}
                variant={'transparent'}
            >
                <IconExclamationCircle
                    color={when({
                        expression: severity,
                        cases: {
                            [ValidationEntrySeverity.FATAL]:
                                'var(--mantine-color-error)',
                            [ValidationEntrySeverity.CRITICAL]:
                                'var(--mantine-color-error)',
                            [ValidationEntrySeverity.WARNING]:
                                'var(--mantine-color-warning)',
                            [ValidationEntrySeverity.NOTE]:
                                'var(--mantine-color-info)',
                        },
                    })}
                />
            </ActionIcon>
        </Tooltip>
    );
};
